import axios from "axios";
import React, { useEffect, useState } from "react";
import { Container } from "react-bootstrap";
import { IoIosArrowForward } from "react-icons/io";
import { useMediaQuery } from "react-responsive";
import { API_URL } from "../API/config";
import { message } from "antd";

export default function Shopbybrand() {
  const [startIndex, setStartIndex] = useState(0);
  const [activeButton, setActiveButton] = useState<"next" | "previous" | null>(
    null
  );
  const [bannerData, setBannerData] = useState<any[]>([]);

  // Use media query to check if the device width is small
  const isSmallDevice = useMediaQuery({ maxWidth: 768 });
  const visibleCount = isSmallDevice ? 2 : 3; // Show 2 images on small devices, 3 on larger devices

  const [messageApi, contextHolder] = message.useMessage();

  const success = (content: any) => {
    messageApi.open({
      type: "success",
      content: content,
      className: "custom-class",
    });
  };

  const errormessage = (content: any) => {
    messageApi.open({
      type: "error",
      content: content,
      className: "custom-class",
    });
  };

  const copyToClipboard = (data: string) => {
    navigator.clipboard
      .writeText(data)
      .then(() => success("Copied!"))
      .catch((error) => {
        console.error("Failed to copy coupon code: ", error);
        errormessage("Failed to copy coupon code!");
      });
  };

  // Fetch banner data
  const getDealBanner = async () => {
    const token = sessionStorage.getItem("token");
 
    try {
      const res = await axios.get(
        `${API_URL}/api/banner/hotDealsSmartPhoneBanners`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      const trueData = res.data.banners.filter(
        (val: any) => val.actionButton === true
      );
      setBannerData(trueData);
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    getDealBanner();
  }, []);

  const totalDivs = bannerData.length;

  const handleNext = () => {
    setActiveButton("next");
    if (startIndex + visibleCount < totalDivs) {
      setStartIndex(startIndex + 1);
    }
    setTimeout(() => setActiveButton(null), 300);
  };

  const handlePrevious = () => {
    setActiveButton("previous");
    if (startIndex > 0) {
      setStartIndex(startIndex - 1);
    }
    setTimeout(() => setActiveButton(null), 300);
  };

  return (
    <>
      {contextHolder}
      <section className="py-4">
        <Container className="w-100">
          <div className=" justify-content-between align-items-center p-0">
            <h2 className="head-txt-1 text-center w-100">
              <div className="heading-box">
                <span>Hot </span> Deals of Smart Phone
              </div>
            </h2>
            <div className="d-flex justify-content-end align-items-center">
              <div className="less-div mx-2">
                <button
                  className={`less ${
                    activeButton === "previous" ? "active" : ""
                  }`}
                  onClick={handlePrevious}
                  disabled={startIndex === 0}
                >
                  <IoIosArrowForward />
                </button>
              </div>

              <div className="greater-div mx-2">
                <button
                  className={`greater ${
                    activeButton === "next" ? "active" : ""
                  }`}
                  onClick={handleNext}
                  disabled={startIndex + visibleCount >= totalDivs}
                >
                  <IoIosArrowForward />
                </button>
              </div>
            </div>
          </div>

          {/* Product Display */}
          <div className="d-flex justify-content-between align-items-center mt-4">
            <div className="d-flex hotdeal-div">
              {bannerData
                .slice(startIndex, startIndex + visibleCount)
                .map((banner) => (
                  <div key={banner._id}>
                    {banner.link !== "" ? (
                      <>
                        <a href={banner.link} target="_blank">
                          <img
                            src={`${API_URL}/images/${banner.image}`}
                            alt={banner._id}
                            className="hotdeal-image img-fluid"
                          />
                        </a>
                      </>
                    ) : (
                      <>
                        <img
                          src={`${API_URL}/images/${banner.image}`}
                          alt={banner._id}
                          className="hotdeal-image img-fluid"
                          onClick={() => copyToClipboard(banner.couponCode)}
                        />
                      </>
                    )}
                  </div>
                ))}
            </div>
          </div>
        </Container>
      </section>
    </>
  );
}
